import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import AppIcon from 'components/common/AppIcon/AppIcon';

import {colors} from 'styles/shared';

const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 6rem;
  margin-top: 3.2rem;
  margin-bottom: 3.5rem;
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
`;

const BackButton = styled.div`
  width: 4.5rem;
  height: 4.5rem;
  background: rgba(227, 236, 255, 0.8);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 2.4rem;
  cursor: pointer;
`;

const Title = styled.div`
  font-size: 3rem;
  line-height: 3.6rem;
  color: ${colors.darkBlue_light};
`;

const Logo = styled.div`
  width: 6rem;
  height: 6rem;
  background-color: ${colors.blue_lighter};
  border-radius: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

AppPageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  goBack: PropTypes.func
};

AppPageHeader.defaultProps = {
  goBack: null
};

function AppPageHeader({title, goBack}) {
  let buttonVisible = goBack ? true : false;

  return (
    <PageHeader>
      <LeftContainer>
        {buttonVisible && (
          <BackButton onClick={goBack}>
            <AppIcon name="less" />
          </BackButton>
        )}

        <Title>{title}</Title>
      </LeftContainer>

      <Logo>
        <AppIcon name="user" />
      </Logo>
    </PageHeader>
  );
}

export default AppPageHeader;
